// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"d3a75ee2","364":"8ba4d312","819":"d5936ec7"}[chunkId] + ".chunk.css";
};